import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import FeatherIcon from 'feather-icons-react';
import { DownOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import 'react-tagsinput/react-tagsinput.css';
import { useSelector } from 'react-redux';
import { Scrollbars } from 'react-custom-scrollbars';
import {
  Image as ImageIcon,
  FileText,
  FileSpreadsheet,
  Presentation,
  FileVideo,
  FileAudio,
  FileArchive,
  File as FileIcon,
} from 'lucide-react';
// import ReactHtmlParser from 'react-html-parser';
import { message, Spin, Input, AutoComplete, Drawer, Space, Modal, Button as Buttons } from 'antd'; // , Popover, Checkbox, 
import propTypes from 'prop-types';
import juice from 'juice';
import { MailBox2 } from './email-style';
import CustomHtmlParser from './CustomHtmlParser'
import TinyMCEEditor from "../EditorFolder/RichEmailEditor"
import { TopToolBoxClone3 } from '../../styled';
import { FetchAllAttendeeList } from '../../../Api/Services/CommonApiService'
import { FetchContactByAccount } from '../../../Api/Services/ContactApiService'
import {
  FetchAllRecentMails1, AIDefatMessage, updateDraftEmail,
  saveDraft, sendTemplateMail, selectEmailTemplate,
  sendDraftEmail, FetchDetailspage,
  deleteDraft,
} from '../../../Api/Services/EmailApiSevices';
import TemplateSelect from '../Popup/TemplateSelectPopup'
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import AiDraftConfirmPopup from '../Popup/AiDraftConfirmPopup'
import { Button } from '../../../components/buttons/buttons';
import { AiIcon, InsertTempIcon } from '../../../components/Icons/Icons';

const MAX_VISIBLE_ROWS = 3;

const C = {
  teal: "#0d9488", tealSoft: "#ccfbf1",
  rose: "#e11d48", roseSoft: "#ffe4e6",
  accent: "#4183f1", accentSoft: "#e3edff",
  green: "#16a34a", greenSoft: "#dcfce7",
  orange: "#ea580c", orangeSoft: "#ffedd5",
  violet: "#7c3aed", violetSoft: "#ede9fe",
  blue: "#2563eb", blueSoft: "#dbeafe",
  amber: "#d97706", amberSoft: "#fef3c7",
  inkMuted: "#6b7280", sunken: "#f3f4f6",
};

const getFileExt = (filename = "") => {
  const idx = filename.lastIndexOf(".");
  return idx > -1 ? filename.slice(idx + 1).toLowerCase() : "";
};

function fileTypeMeta(ext) {
  const image = ["png", "jpg", "jpeg", "gif", "svg", "webp", "bmp", "ico", "avif"];
  const doc = ["doc", "docx", "txt", "rtf"];
  const sheet = ["xls", "xlsx", "csv"];
  const pdf = ["pdf"];
  const video = ["mp4", "webm", "mov"];
  const archive = ["zip", "rar", "7z"];
  const presentation = ["ppt", "pptx"];
  const audio = ["mp3", "wav", "aac", "ogg", "m4a"];
  if (image.includes(ext)) {
    return { label: "Image", icon: ImageIcon, color: C.teal, soft: C.tealSoft };
  }
  if (pdf.includes(ext)) {
    return { label: "PDF", icon: FileText, color: C.rose, soft: C.roseSoft };
  }
  if (doc.includes(ext)) {
    return { label: "Document", icon: FileText, color: C.accent, soft: C.accentSoft };
  }
  if (sheet.includes(ext)) {
    return { label: "Spreadsheet", icon: FileSpreadsheet, color: C.green, soft: C.greenSoft };
  }
  if (presentation.includes(ext)) {
    return { label: "Presentation", icon: Presentation, color: C.orange, soft: C.orangeSoft };
  }
  if (video.includes(ext)) {
    return { label: "Video", icon: FileVideo, color: C.violet, soft: C.violetSoft };
  }
  if (audio.includes(ext)) {
    return { label: "Audio", icon: FileAudio, color: C.blue, soft: C.blueSoft };
  }
  if (archive.includes(ext)) {
    return { label: "Archive", icon: FileArchive, color: C.amber, soft: C.amberSoft };
  }
  return {
    label: ext ? ext.toUpperCase() : "File",
    icon: FileIcon,
    color: C.inkMuted,
    soft: C.sunken,
  };
}

function useRecipientOverflow(items, expanded) {
  const measureRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  useLayoutEffect(() => {
    const measureEl = measureRef.current;
    if (!measureEl) return undefined;

    const recompute = () => {
      if (expanded) return;

      const children = Array.from(measureEl.children);

      if (children.length === 0) {
        setVisibleCount(null);
        setHasOverflow(false);
        return;
      }
      const rowTops = [];
      children.forEach((el) => {
        const top = el.offsetTop;

        if (!rowTops.includes(top)) {
          rowTops.push(top);
        }
      });

      if (rowTops.length <= MAX_VISIBLE_ROWS) {
        setVisibleCount(items.length);
        setHasOverflow(false);
        return;
      }
      const cutoffTop = rowTops[MAX_VISIBLE_ROWS - 1];
      const count = children
        .filter(
          (el) => el.offsetTop <= cutoffTop
        ).length - 1;

      setVisibleCount(Math.max(count, 0));
      setHasOverflow(true);
    };

    recompute();

    const resizeObserver = new ResizeObserver(() => {
      recompute();
    });

    resizeObserver.observe(measureEl);

    return () => resizeObserver.disconnect();
  }, [items, expanded]);

  return { measureRef, visibleCount, hasOverflow };
}
function Compose({ close, mailOpen, IsTrackUrl, entity, entityName, toId, entityUId, setNaCTrigger, Comefrom, setTemplateIDSS, searchText, templateIDSS, DeleteDraftForever, SendFunction, detailsPage, setDetailsData, DraftFunction, replyToPopup, forwardformatss, AccountId, CallBackTrigger, isCancel }) { // TrashFunction, MovetoTrash, dbMailId, setDbMailId,
  const { emailapiValues } = useSelector((state) => state.EmailData);
  const localData = useSelector((state) => state.localRedux);
  const companyProfile = localData.company
  const ProfileData = localData.profile
  const profile = ProfileData;
  const loadingRef = useRef(false);
  const [doubleClick, setDoubleClick] = useState(false)
  const [doubleClick1, setDoubleClick1] = useState(false)
  const [doubleClick2, setDoubleClick2] = useState(false)
  const [openTemplate, setOpenTemplate] = useState(false)
  const [popupMessage, setPopupMessage] = useState(false)
  const [mailSaveId, setMailSaveId] = useState()
  const [typeOfPge, setTypeOfPge] = useState()
  const [entityId, setEntityId] = useState()
  const [forwardformat, setForwardformat] = useState()
  const [page, setPage] = useState()
  const [state, setState] = useState({
    size: 'small',
    tags: [],
  });
  const normalizeValue = (value) => {
    if (value == null) return null;
    const trimmed = value?.trim?.();
    if (trimmed === "") return null;
    return trimmed ?? value;
  };
  const replacePTagsWithDiv = (html) => {
    return html
      .replace(/<p(\s[^>]*)?>/gi, "<div>")
      .replace(/<\/p>/gi, "</div>");
  };
  const [disabled, setDisbled] = useState(false)
  // const [replayTo, setReplayTo] = useState()
  const [CcOpen, setCcOpen] = useState(false)
  const [CcData, setCcData] = useState([])
  const [BccOpen, setBccOpen] = useState(false)
  const [BccData, setBccData] = useState([])
  const [linkType, setLinkType] = useState('Contacts_Leads,Accounts');
  const [subject, setSubject] = useState("")
  const [content, setContent] = useState("");
  const [templateId, setTemplateId] = useState({ id: null, key: 0 })
  const [templateID, setTemplateID] = useState()
  const [files, setFiles] = useState([]);
  const [composeSize, setComposeSize] = useState(600)
  const [aiCompose, setAiCompose] = useState(false)
  const [showAllTo, setShowAllTo] = useState(false)
  const [showAllCc, setShowAllCc] = useState(false)
  const [showAllBcc, setShowAllBcc] = useState(false)
  const [aiContent, setAiContent] = useState()
  const [showAiDraftConfirm, setShowAiDraftConfirm] = useState(false)
  const [dragOverField, setDragOverField] = useState(null)
  const [draggingKey, setDraggingKey] = useState(null)
  const dragPreviewRef = useRef(null)
  const edit = true;
  const [participantData, setParticipantData] = useState([])
  const [participantData2, setParticipantData2] = useState([])
  // To
  const [toInputValue, setToInputValue] = useState('');
  const [toOptions, setToOptions] = useState([]);
  const [toSelectedItems, setToSelectedItems] = useState([]);
  // CC
  const [ccInputValue, setCcInputValue] = useState('');
  const [ccOptions, setCcOptions] = useState([]);
  const [ccSelectedItems, setCcSelectedItems] = useState([]);
  // Bcc
  const [bccInputValue, setBccInputValue] = useState('');
  const [bccOptions, setBccOptions] = useState([]);
  const [bccSelectedItems, setBccSelectedItems] = useState([]);
  // const [templateData, setTemplateData] = useState(null)

  // Dynamic row-based overflow measurement ("slice") for each recipient field.
  const toOverflow = useRecipientOverflow(toSelectedItems, showAllTo);
  const ccOverflow = useRecipientOverflow(ccSelectedItems, showAllCc);
  const bccOverflow = useRecipientOverflow(bccSelectedItems, showAllBcc);

  const toggleSize = (value) => {
    setComposeSize(value)
  }
  const OpenTemplates = () => {
    setOpenTemplate(true)
  }
  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = days[date.getUTCDay()];
    const month = months[date.getUTCMonth()];
    const dayOfMonth = date.getUTCDate();
    const year = date.getUTCFullYear();
    const hour = date.getUTCHours();
    const minute = date.getUTCMinutes();
    const formattedDate = `${day}, ${month} ${dayOfMonth} ${year} ${hour}:${minute < 10 ? `0${minute}` : minute}`;
    return formattedDate;
  };
  const sanitizeEmailContent = (html) => {
    if (!html) return html;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    doc.querySelectorAll("img").forEach((img) => {
      const src = img.getAttribute("src") || "";
      if (src.includes("/api/openRates/")) {
        const parent = img.parentElement;
        if (parent && parent.children.length === 1 && parent.tagName === "DIV") {
          parent.remove();
        } else {
          img.remove();
        }
      }
    });

    doc.querySelectorAll('[id^="unsubscribe-block"]').forEach((el) => el.remove());

    const clickUrlPattern = /\/api\/clickURL\/[^/]+\/[^/?]+\?redirect=(.+)/;
    doc.querySelectorAll("[href], [src]").forEach((el) => {
      ["href", "src"].forEach((attr) => {
        const val = el.getAttribute(attr);
        if (!val) return;
        const match = val.match(clickUrlPattern);
        if (match) {
          try {
            el.setAttribute(attr, decodeURIComponent(match[1]));
          } catch {
            el.setAttribute(attr, match[1]);
          }
        }
      });
    });

    return doc.body.innerHTML;
  };
  const setTemplateContant = async (value) => {
    const cleaned = sanitizeEmailContent(value?.content);
    setSubject(value?.templateSubject)
    setContent(cleaned);
  }
  async function getcontent() {
    try {
      const data = await selectEmailTemplate(templateId.id, entityName, entityId)
      setTemplateContant(data);
      setTemplateId({ id: null, key: 0 })
    } catch (error) {
      setTemplateId({ id: null, key: 0 })
      message.error(error);
    }
  }
  useEffect(() => {
    if (templateIDSS) {
      setMailSaveId(templateIDSS)
    }
  }, [templateIDSS])
  useEffect(() => {
    if (mailOpen) {
      if (templateId.id) {
        getcontent()
      }
    }
  }, [templateId, entityName, mailOpen])
  useEffect(() => {
    if (mailOpen) {
      setTypeOfPge(replyToPopup)
      if (forwardformatss) {
        setForwardformat(forwardformatss)
        if (replyToPopup === "Forward") {
          const { date, from, to, cc, subject, body, attachment } = forwardformatss;
          const fromAddress = from?.address || from.email
          const toAddress = to?.map((item) => (item.address || item.email)).join(", ")
          const ccAddress = cc?.map((item) => (item.address || item.email)).join(", ")
          const inlinedHtml = juice(body);
          const finalHtml = inlinedHtml
            .replace(/<!DOCTYPE html>/, '')
            .replace(/<html[^>]*>/, '')
            .replace(/<\/html>/, '')
            .replace(/<head>.*<\/head>/s, '')
            .replace(/<body[^>]*>/, match => {
              const bodyStyleMatch = match.match(/style="([^"]*)"/);
              return `<div style="${bodyStyleMatch ? bodyStyleMatch[1] : ''}">`;
            })
            .replace('</body>', '</div>')
            .trim();
          const emailContent = `
  <div><br></div>
  <div contenteditable='false'id="ForwardContent">
    <hr style="border: 1px solid #ccc; margin: 20px 0;" />
    <div style="margin: 20px 0; font-family:'Noto Sans', sans-serif;">
      <div>============ Forwarded message ============</div>
      <div><strong>From:</strong> ${fromAddress}</div>
      <div><strong>To:</strong> ${toAddress}</div>
      <div><strong>Cc:</strong> ${ccAddress}</div>
      <div><strong>Date:</strong> ${date}</div>
      <div><strong>Subject:</strong> ${subject}</div>
      <div>============ Forwarded message ============</div>
    </div>
    ${finalHtml}
  </div>
`;
          setContent(emailContent)
          setSubject(`Fwd: ${subject}`)
          setFiles(attachment.filter((attachment) => attachment.contentDisposition === "attachment"));
        }
        if (replyToPopup === "DraftDetail") {
          if (forwardformatss) {
            if (forwardformatss?.cc?.length > 0) { setCcOpen(true) }
            else { setCcOpen(false) }
            if (forwardformatss?.bcc.length > 0) { setBccOpen(true) }
            else { setBccOpen(false) }
            setLinkType("Contacts_Leads,Accounts")
            setSubject(forwardformatss?.subject)
            setContent(forwardformatss?.body);
            setFiles(forwardformatss?.attachments.filter((attachment) => attachment.contentDisposition === "attachment"));
          }
        }
        if (replyToPopup === "Reply To" || replyToPopup === "Reply All") {
          const { date, from, body, subject } = forwardformatss;
          const inlinedHtml = juice(body);
          const finalHtml = inlinedHtml
            .replace(/<!DOCTYPE html>/, '')
            .replace(/<html[^>]*>/, '')
            .replace(/<\/html>/, '')
            .replace(/<head>.*<\/head>/s, '')
            .replace(/<body[^>]*>/, match => {
              const bodyStyleMatch = match.match(/style="([^"]*)"/);
              return `<div style="${bodyStyleMatch ? bodyStyleMatch[1] : ''}">`;
            })
            .replace('</body>', '</div>')
            .trim();
          const emailContent = `
        <div><br></div>
        <div contenteditable='false' id="ReplyContent">
        <hr style="border: 1px solid #ccc; margin: 20px 0;" />
        <div class="quoted">
        <div>---- On ${formatDate(date)}, <strong>${from?.address || from.email}</strong> wrote ----</div>
        <blockquote>
        ${finalHtml}
        </blockquote>
        </div> 
        </div>
      `;
          setContent(emailContent)
          const formattedSubject = subject?.trim().toLowerCase().startsWith("re:")
            ? subject
            : `Re: ${subject}`;

          setSubject(formattedSubject);
        }
      }
    }
  }, [replyToPopup, forwardformatss, mailOpen])
  function normalizeEmailData(input) {
    const cleanString = (str) => str.trim().replace(/^["']|["']$/g, "");
    const parseEmail = (emailString) => {
      emailString = cleanString(emailString);
      const match = emailString.match(/(.*)<(.+)>/);
      if (match) {
        return {
          name: cleanString(match[1]),
          address: match[2].trim(),
        };
      }
      return {
        name: "",
        address: emailString,
      };
    };
    const normalizeField = (field) => {
      if (!field) return [];
      return field.split(",").map((item) => parseEmail(item.trim()));
    };
    const BodywithLinks = (data) => {
      const urlPattern = /(https?:\/\/[^\s]+)/g;
      const formattedMessage = data.replace(urlPattern, (url) => {
        const escapedUrl = encodeURIComponent(url);
        return `<a href="${escapedUrl}" target="_blank">${url}</a>`;
      });
      return formattedMessage.replace(/\n/g, '<br />');
    };
    const formattedFrom = parseEmail(input.from || "");
    const formattedTo = normalizeField(input.to || "");
    const formattedCc = normalizeField(input.cc || "");
    const formattedBcc = normalizeField(input.bcc || "");
    let bodyText = "";
    if (emailapiValues?.emailType === "Outlook") {
      bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
    }
    else if (emailapiValues?.emailType === "Google" || emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
      bodyText = input ? (input?.htmlContent && input?.htmlContent !== "") ? input.htmlContent : input?.textContent ? BodywithLinks(input.textContent) : "" : ""
    }
    return {
      ...input,
      subject: input ? input.subject !== "" && input.subject ? input.subject : "(No Subject)" : "(No Subject)",
      from: formattedFrom,
      to: formattedTo,
      cc: formattedCc,
      bcc: formattedBcc,
      body: bodyText,
    };
  }
  function normalizeEmailDataforOutlook(input) {
    let bodyText = "";
    if (emailapiValues?.emailType === 'Outlook') {
      bodyText = input ? input?.bodyContent ? input.bodyContent : "" : ""
    }
    return {
      ...input,
      body: bodyText,
    };
  }
  async function getDetailsApi(detailsPage, detailsId) {
    setForwardformat()
    try {
      const data = await FetchDetailspage(detailsId, detailsPage)
      if (data.code === 200) {
        let modifiedData;
        const originalData = data.data;
        if (emailapiValues?.emailType === 'Outlook') {
          modifiedData = normalizeEmailDataforOutlook(originalData);
        } else if (emailapiValues?.emailType === 'Google' || emailapiValues?.emailType === 'Zoho' || emailapiValues?.emailType === "Other Email") {
          modifiedData = normalizeEmailData(originalData);
        };
        setForwardformat(modifiedData)
        setTemplateId({ id: null, key: 0 })
      }
      else {
        setDisbled(false)
        setForwardformat()
        if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
          DraftFunction("Drafts", 1, searchText)
          if (isCancel === "Yes") { setTemplateIDSS() }
        }
        close()
        setPopupMessage(false)
        setState({
          size: 'small',
          tags: [],
        });
        setMailSaveId()
        setToInputValue('')
        setToSelectedItems([])
        setCcInputValue('')
        setBccInputValue('')
        setBccOptions([])
        setBccSelectedItems([])
        setCcSelectedItems([])
        setCcOptions([])
        setToOptions([])
        setCcOpen(false)
        setCcData([])
        setBccOpen(false)
        setBccData([])
        setLinkType("Contacts_Leads,Accounts")
        setTemplateId({ id: null, key: 0 })
        setSubject("")
        setContent("");
        message.error("The email you're trying to open has been deleted or no longer exists. It may have been moved, archived, or permanently removed")
      }
    }
    catch (error) {
      setDisbled(false)
      setForwardformat()
      if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
        DraftFunction("Drafts", 1, searchText)
        if (isCancel === "Yes") { setTemplateIDSS() }
      }
      close()
      setPopupMessage(false)
      setState({
        size: 'small',
        tags: [],
      });
      setMailSaveId()
      setToInputValue('')
      setToSelectedItems([])
      setCcInputValue('')
      setBccInputValue('')
      setBccOptions([])
      setBccSelectedItems([])
      setCcSelectedItems([])
      setCcOptions([])
      setToOptions([])
      setCcOpen(false)
      setCcData([])
      setBccOpen(false)
      setBccData([])
      setLinkType("Contacts_Leads,Accounts")
      setTemplateId({ id: null, key: 0 })
      setSubject("")
      setContent("");
      message.error("The email you're trying to open has been deleted or no longer exists. It may have been moved, archived, or permanently removed")
    }
  }
  const onEmailSend = async (id) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setDoubleClick(true)
    const formattedHtmlContent = `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html><head><meta content="text/html;charset=UTF-8" http-equiv="Content-Type"><link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"rel="stylesheet"></head><body><div>${content}</div></body></html>`;
    setDisbled(true)
    const payload = {
      to: state.tags,
      content: formattedHtmlContent,
      subject: normalizeValue(subject && subject !== "" ? subject : "(No Subject)"),
      cc: CcData,
      bcc: BccData,
      attachments: files,

    }
    let hideMessage;
    if (id) {
      hideMessage = message.loading("Sending Email", 0);
      try {
        const response = await sendDraftEmail(id, linkType, payload)
        if (response.status === 201) {
          if (entity === "EntityPages") {
            setTimeout(() => {
              FetchAllRecentMails1("Sent")
                .then(() => {
                  CallBackTrigger("Callback");
                })
                .catch(err => {
                  CallBackTrigger("Callback");
                  console.error("Error fetching recent mails:", err);
                });
            }, 2000);
          }
          hideMessage();
          setDisbled(false)
          if (Comefrom === "Entity" || Comefrom === "Entitys") {
            setTimeout(() => {
              FetchAllRecentMails1("Sent")
                .then(() => {
                  if (Comefrom === "Entity") {
                    setNaCTrigger("CallBack")
                  }
                })
                .catch(err => {
                  if (Comefrom === "Entity") {
                    setNaCTrigger("CallBack")
                  }
                  console.error("Error fetching recent mails:", err);
                });
            }, 2000);
          }
          if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
            DraftFunction("Drafts", 1, searchText)
            setTimeout(() => {
              SendFunction("Sent", 1, searchText)
            }, 3000);
            if (isCancel === "Yes") { setTemplateIDSS() }
          }
          close()
          setState({
            size: 'small',
            tags: [],
          });
          setMailSaveId()
          setToInputValue('')
          setToSelectedItems([])
          setCcInputValue('')
          setBccInputValue('')
          setBccOptions([])
          setBccSelectedItems([])
          setCcSelectedItems([])
          setCcOptions([])
          setToOptions([])
          setCcOpen(false)
          setCcData([])
          setBccOpen(false)
          setBccData([])
          setLinkType("Contacts_Leads,Accounts")
          setTemplateId({ id: null, key: 0 })
          setSubject("")
          setContent("");
          message.success("Email sent")
          loadingRef.current = false;
          setDoubleClick(false)
        }
      }
      catch (error) {
        loadingRef.current = false;
        setDoubleClick(false)
        hideMessage();
        setDisbled(false)
        message.error(error);
      }
    } else {
      hideMessage = message.loading("Sending Email", 0);
      try {
        const linksend = entityName === "Deals" ? `Deals?linkTypeId=${entityUId}` : linkType
        const response = await sendTemplateMail(linksend, payload)
        if (entity === "EntityPages") {
          setTimeout(() => {
            FetchAllRecentMails1("Sent")
              .then(() => {
                CallBackTrigger("Callback");
              })
              .catch(err => {
                CallBackTrigger("Callback");
                console.error("Error fetching recent mails:", err);
              });
          }, 2000);
        }
        if (response.status === 201) {
          hideMessage();
          setDisbled(false)
          if (Comefrom === "Entity" || Comefrom === "Entitys") {
            setTimeout(() => {
              FetchAllRecentMails1("Sent")
                .then(() => {
                  if (Comefrom === "Entity") {
                    setNaCTrigger("CallBack")
                  }
                })
                .catch(err => {
                  if (Comefrom === "Entity") {
                    setNaCTrigger("CallBack")
                  }
                  console.error("Error fetching recent mails:", err);
                });
            }, 2000);
          }
          if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
            setTimeout(() => {
              SendFunction("Sent", 1, searchText)
            }, 3000);
            if (isCancel === "Yes") { setTemplateIDSS() }
          }
          close()
          setState({
            size: 'small',
            tags: [],
          });
          setMailSaveId()
          setToInputValue('')
          setToSelectedItems([])
          setCcInputValue('')
          setBccInputValue('')
          setBccOptions([])
          setBccSelectedItems([])
          setCcSelectedItems([])
          setCcOptions([])
          setToOptions([])
          setCcOpen(false)
          setCcData([])
          setBccOpen(false)
          setBccData([])
          setLinkType("Contacts_Leads,Accounts")
          setTemplateId({ id: null, key: 0 })
          setSubject("")
          setContent("");
          message.success("Email sent")
        }
        loadingRef.current = false;
        setDoubleClick(false)
      }
      catch (error) {
        loadingRef.current = false;
        setDoubleClick(false)
        hideMessage();
        setDisbled(false)
        message.error(error);
      }
    }
  }
  const onDeleteSend = async (id) => {
    if (id) {
      if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
        setDisbled(true)
        DeleteDraftForever([{ mailId: id }])
        if (entity === "MailPage") {
          setDetailsData()
          setForwardformat()
          if (isCancel === "Yes") { setTemplateIDSS() }
        }
        setState({
          size: 'small',
          tags: [],
        });
        setMailSaveId()
        setToInputValue('')
        setToSelectedItems([])
        setCcInputValue('')
        setBccInputValue('')
        setBccOptions([])
        setBccSelectedItems([])
        setCcSelectedItems([])
        setCcOptions([])
        setToOptions([])
        setCcOpen(false)
        setCcData([])
        setBccOpen(false)
        setBccData([])
        setLinkType("Contacts_Leads,Accounts")
        setTemplateId({ id: null, key: 0 })
        setSubject("")
        setContent("");
        setPopupMessage(false)
        close()
        setDisbled(false)
      }
      else {
        let hideMessage;
        setDisbled(true)
        setMailSaveId()
        if (id) {
          const payload = {
            mailIds: [id]
          }
          hideMessage = message.loading("Deleting from Drafts...", 0);
          try {
            deleteDraft(payload)
            hideMessage();
            message.success('Draft(s) deleted forever');
            if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
              setDetailsData()
              setForwardformat()
              if (isCancel === "Yes") { setTemplateIDSS() }
            }
            setState({
              size: 'small',
              tags: [],
            });
            setMailSaveId()
            setToInputValue('')
            setToSelectedItems([])
            setCcInputValue('')
            setBccInputValue('')
            setBccOptions([])
            setBccSelectedItems([])
            setCcSelectedItems([])
            setCcOptions([])
            setToOptions([])
            setCcOpen(false)
            setCcData([])
            setBccOpen(false)
            setBccData([])
            setLinkType("Contacts_Leads,Accounts")
            setTemplateId({ id: null, key: 0 })
            setSubject("")
            setContent("");
            setPopupMessage(false)
            close()
            setDisbled(false)
          } catch (error) {
            hideMessage();
            message.error(error);
          }
        }
      }
    }
    else {
      setMailSaveId()
      setDisbled(true)
      if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
        setDetailsData()
        setForwardformat()
        if (isCancel === "Yes") { setTemplateIDSS() }
      }
      setState({
        size: 'small',
        tags: [],
      });
      setToInputValue('')
      setToSelectedItems([])
      setCcInputValue('')
      setBccInputValue('')
      setBccOptions([])
      setBccSelectedItems([])
      setCcSelectedItems([])
      setCcOptions([])
      setToOptions([])
      setCcOpen(false)
      setCcData([])
      setBccOpen(false)
      setBccData([])
      setLinkType("Contacts_Leads,Accounts")
      setTemplateId({ id: null, key: 0 })
      setSubject("")
      setContent("");
      setPopupMessage(false)
      close()
      setDisbled(false)
    }
  }
  const onDraftSend = async (id, type, action) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setDoubleClick1(true)
    if (toSelectedItems?.length) {
      const formattedHtmlContent = `<!DOCTYPE html PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN"><html><head><meta content="text/html;charset=UTF-8" http-equiv="Content-Type"><link href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&family=Story+Script&display=swap"rel="stylesheet"></head><body><div>${content}</div></body></html>`;
      setDisbled(true)
      const payload = {
        to: state.tags,
        content: formattedHtmlContent,
        subject: normalizeValue(subject && subject !== "" ? subject : "(No Subject)"),
        cc: CcData,
        bcc: BccData,
        attachments: files,
      }
      let hideMessage;
      if (id) {
        try {
          hideMessage = message.loading("Saving Draft Email", 0);
          const response = await updateDraftEmail(payload, id)
          if (response.status === 200) {
            hideMessage();
            if (type === "Save") {
              setDisbled(false)
              setForwardformat()
              setTypeOfPge("DraftDetail")
              if (action === "Close") {
                setMailSaveId()
                setDisbled(false)
                setForwardformat()
                if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                  if (isCancel === "Yes") { setTemplateIDSS() }
                  DraftFunction("Drafts", 1, searchText)
                }
                close()
                setPopupMessage(false)
                setState({
                  size: 'small',
                  tags: [],
                });
                setToInputValue('')
                setToSelectedItems([])
                setCcInputValue('')
                setBccInputValue('')
                setBccOptions([])
                setBccSelectedItems([])
                setCcSelectedItems([])
                setCcOptions([])
                setToOptions([])
                setCcOpen(false)
                setCcData([])
                setBccOpen(false)
                setBccData([])
                setLinkType("Contacts_Leads,Accounts")
                setTemplateId({ id: null, key: 0 })
                setSubject("")
                setContent("");
              }
              else if (action !== "Close") {
                if (emailapiValues?.emailType === "Google") {
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS(response.data.data.message.id) }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  setMailSaveId(response.data.data.message.id)
                  getDetailsApi("Drafts", response.data.data.message.id)
                  setSubject(normalizeValue(subject && subject !== "" ? subject : "(No Subject)"))
                  setFiles([])
                }
                if (emailapiValues?.emailType === "Outlook") {
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS(response.data.mailId) }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  setMailSaveId(response.data.mailId)
                  getDetailsApi("Drafts", response.data.mailId)
                  setSubject(normalizeValue(subject && subject !== "" ? subject : "(No Subject)"))
                  setFiles([])
                }
                if (emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
                  setMailSaveId()
                  setDisbled(false)
                  setForwardformat()
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS() }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  close()
                  setPopupMessage(false)
                  setState({
                    size: 'small',
                    tags: [],
                  });
                  setToInputValue('')
                  setToSelectedItems([])
                  setCcInputValue('')
                  setBccInputValue('')
                  setBccOptions([])
                  setBccSelectedItems([])
                  setCcSelectedItems([])
                  setCcOptions([])
                  setToOptions([])
                  setCcOpen(false)
                  setCcData([])
                  setBccOpen(false)
                  setBccData([])
                  setLinkType("Contacts_Leads,Accounts")
                  setTemplateId({ id: null, key: 0 })
                  setSubject("")
                  setContent("");
                }
              }
            }
            message.success("Email draft saved")
            loadingRef.current = false;
            setDoubleClick1(false)
          }
        }
        catch (error) {
          loadingRef.current = false;
          setDoubleClick1(false)
          hideMessage();
          setDisbled(false)
          message.error(error);
        }
      } else {
        try {
          hideMessage = message.loading("Saving Draft Email", 0);
          const response = await saveDraft(payload)
          if (response.status === 201) {
            hideMessage();
            if (type === "Save") {
              setDisbled(false)
              setForwardformat()
              setTypeOfPge("DraftDetail")
              if (action === "Close") {
                setMailSaveId()
                setDisbled(false)
                setForwardformat()
                if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                  if (isCancel === "Yes") { setTemplateIDSS() }
                  DraftFunction("Drafts", 1, searchText)
                }
                close()
                setPopupMessage(false)
                setState({
                  size: 'small',
                  tags: [],
                });
                setToInputValue('')
                setToSelectedItems([])
                setCcInputValue('')
                setBccInputValue('')
                setBccOptions([])
                setBccSelectedItems([])
                setCcSelectedItems([])
                setCcOptions([])
                setToOptions([])
                setCcOpen(false)
                setCcData([])
                setBccOpen(false)
                setBccData([])
                setLinkType("Contacts_Leads,Accounts")
                setTemplateId({ id: null, key: 0 })
                setSubject("")
                setContent("");
              }
              else if (action !== "Close") {
                if (emailapiValues?.emailType === "Google") {
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS(response.data.data.message.id) }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  setMailSaveId(response.data.data.message.id)
                  getDetailsApi("Drafts", response.data.data.message.id)
                  setSubject(normalizeValue(subject && subject !== "" ? subject : "(No Subject)"))
                }
                if (emailapiValues?.emailType === "Outlook") {
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS(response.data.data.mailId) }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  setMailSaveId(response.data.data.mailId)
                  getDetailsApi("Drafts", response.data.data.mailId)
                  setSubject(normalizeValue(subject && subject !== "" ? subject : "(No Subject)"))
                }
                if (emailapiValues?.emailType === "Zoho" || emailapiValues?.emailType === "Other Email") {
                  setMailSaveId()
                  setDisbled(false)
                  setForwardformat()
                  if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
                    if (isCancel === "Yes") { setTemplateIDSS() }
                    DraftFunction("Drafts", 1, searchText)
                  }
                  close()
                  setPopupMessage(false)
                  setState({
                    size: 'small',
                    tags: [],
                  });
                  setToInputValue('')
                  setToSelectedItems([])
                  setCcInputValue('')
                  setBccInputValue('')
                  setBccOptions([])
                  setBccSelectedItems([])
                  setCcSelectedItems([])
                  setCcOptions([])
                  setToOptions([])
                  setCcOpen(false)
                  setCcData([])
                  setBccOpen(false)
                  setBccData([])
                  setLinkType("Contacts_Leads,Accounts")
                  setTemplateId({ id: null, key: 0 })
                  setSubject("")
                  setContent("");
                }
              }
            }
            message.success("Email draft saved")
            loadingRef.current = false;
            setDoubleClick1(false)
          }
        }
        catch (error) {
          loadingRef.current = false;
          setDoubleClick1(false)
          hideMessage();
          setDisbled(false)
          message.error(error);
        }
      }
    }
    else {
      loadingRef.current = false;
      setDoubleClick1(false)
      message.error("Please add at least one recipient to save the draft");
    }
  }
  const onclose = (id, page) => {
    setPopupMessage(true)
    setTemplateID(id)
    setPage(page)
  }
  const onclose2 = () => {
    setPopupMessage(false)
    setTemplateID()
    setPage()
  }
  const OnCancel = () => {
    setTemplateID()
    setPage()
    setMailSaveId()
    setDisbled(false)
    setForwardformat()
    if (entity === "MailPage" && Comefrom !== "Entity" && Comefrom !== "Entitys") {
      if (isCancel === "Yes") { setTemplateIDSS() }
      DraftFunction("Drafts", 1, searchText)
    }
    close()
    setPopupMessage(false)
    setState({
      size: 'small',
      tags: [],
    });
    setToInputValue('')
    setToSelectedItems([])
    setCcInputValue('')
    setBccInputValue('')
    setBccOptions([])
    setBccSelectedItems([])
    setCcSelectedItems([])
    setCcOptions([])
    setToOptions([])
    setCcOpen(false)
    setCcData([])
    setBccOpen(false)
    setBccData([])
    setLinkType("Contacts_Leads,Accounts")
    setTemplateId({ id: null, key: 0 })
    setSubject("")
    setContent("");
  }
  const standardizeObjectFormat = (obj) => {
    const standardizedObj = {
      id: obj?.id || "",
      name: obj?.name || "",
      type: obj?.type || "",
      email: obj?.email || ""
    };
    return standardizedObj;
  };
  const processEmails = (emailString) => {
    const newUserList = emailString.map(replayids => {
      let userData = participantData.find(item => item.email === replayids);
      if (!userData) {
        userData = {
          id: "",
          name: replayids,
          type: "Others",
          email: replayids,
        };
      }
      else {
        userData = {
          id: userData.id,
          name: userData.name,
          type: userData.type,
          email: userData.email,
        };
      }
      return userData;
    });
    return newUserList;
  };
  const processEmails2 = (emailString) => {
    const newUserList = emailString.map(replayids => {
      let userData = participantData2.find(item => item.email === replayids);
      if (!userData) {
        userData = {
          id: "",
          name: replayids,
          type: "Others",
          email: replayids,
        };
      }
      else {
        userData = {
          id: userData.id,
          name: userData.name,
          type: userData.type,
          email: userData.email,
        };
      }
      return userData;
    });
    return newUserList;
  };
  const Emailsarray = (emailString) => {
    const newUserList = emailString.map(replayids => {
      let userData = participantData.find(item => item.id === Number(replayids.id) && item.type === replayids.type);
      userData = {
        id: userData?.id,
        name: userData?.name,
        type: userData?.type,
        email: userData?.email,
      };
      return userData;
    });
    return newUserList;
  };
  async function getPartcipants() {
    try {
      const data = await FetchAllAttendeeList()
      setParticipantData2(data)
      let UserListData;
      if (entityName === "Leads") {
        UserListData = data.filter((item) => item.type === "Leads")
      }
      else if (entityName === "Contacts") {
        UserListData = data.filter((item) => item.type === "Contacts")
      }
      else if (entityName === "Deals" || entityName === "Accounts") {
        try {
          const response = await FetchContactByAccount(AccountId)
          UserListData = response.map(contact => ({
            id: contact.contacts_id,
            name: `${contact.first_name} ${contact.last_name}`,
            email: contact.email,
            type: 'Contacts'
          }));
        } catch (error) {
          message.error(error)
        }
      }
      else if (entityName === "Tasks") {
        UserListData = data.filter((item) => item.type === "User")
      }
      else {
        UserListData = data
      }
      setParticipantData(UserListData)
    } catch (error) {
      message.error(error)
    }
  };
  const handleCcOpen = () => {
    setCcOpen(true)
  }
  const handleBccOpen = () => {
    setBccOpen(true)
  }
  // ---- Multi-email paste support helpers ----
  const splitEmails = (raw) => raw
    ?.split(/[,;\s]+/)
    ?.map((e) => e.trim())
    ?.filter(Boolean);

  const isValidEmail = (val) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  const handleToChange = (value) => {
    const input = typeof value === "string" ? value : "";
    const tokens = splitEmails(input);
    if (tokens.length <= 1) {
      setToInputValue(input);
      return;
    }
    const validEmails = tokens.filter(isValidEmail);
    const invalidCount = tokens.length - validEmails.length;
    const seenEmails = new Set(
      toSelectedItems.map((item) => item.email?.toLowerCase()).filter(Boolean)
    );
    const newItems = [];
    validEmails.forEach((rawEmail) => {
      const email = rawEmail.trim();
      const lowerEmail = email.toLowerCase();
      if (seenEmails.has(lowerEmail)) return;
      seenEmails.add(lowerEmail);
      const found = participantData.find((item) => item.email?.toLowerCase() === lowerEmail);
      newItems.push(
        found ? standardizeObjectFormat(found) : { id: "", name: email, type: "Others", email }
      );
    });
    if (newItems.length) {
      const updated = [...toSelectedItems, ...newItems];
      setToSelectedItems(updated);
      setState((prev) => ({ ...prev, tags: updated }));
      if (templateId?.id) {
        setSubject("");
        setTemplateId({ id: null, key: 0 });
        setContent("");
      }
    }
    if (invalidCount > 0) {
      message.warning(`${invalidCount} invalid email${invalidCount > 1 ? "s" : ""} skipped`);
    }
    const invalidEmails = tokens.filter((email) => !isValidEmail(email));
    setTimeout(() => {
      setToInputValue(invalidEmails.length ? invalidEmails.join(", ") : "");
      setToOptions([]);
    }, 50);
  };
  const handleCcPaste = (value) => {
    const input = typeof value === "string" ? value : "";
    const tokens = splitEmails(input);
    if (tokens.length <= 1) {
      setCcInputValue(input);
      return;
    }
    const validEmails = tokens.filter(isValidEmail);
    const invalidCount = tokens.length - validEmails.length;
    const seenEmails = new Set(
      ccSelectedItems.map((item) => item.email?.toLowerCase()).filter(Boolean)
    );
    const newItems = [];
    validEmails.forEach((rawEmail) => {
      const email = rawEmail.trim();
      const lowerEmail = email.toLowerCase();
      if (seenEmails.has(lowerEmail)) return;
      seenEmails.add(lowerEmail);
      const found = participantData2.find((item) => item.email?.toLowerCase() === lowerEmail);
      newItems.push(
        found ? standardizeObjectFormat(found) : { id: "", name: email, type: "Others", email }
      );
    });
    if (newItems.length) {
      const updated = [...ccSelectedItems, ...newItems];
      setCcSelectedItems(updated);
      setCcData(updated);
    }
    if (invalidCount > 0) {
      message.warning(`${invalidCount} invalid email${invalidCount > 1 ? "s" : ""} skipped`);
    }
    const invalidEmails = tokens.filter((email) => !isValidEmail(email));
    setTimeout(() => {
      setCcInputValue(invalidEmails.length ? invalidEmails.join(", ") : "");
      setCcOptions([]);
    }, 50);
  };
  const handleBccPaste = (value) => {
    const input = typeof value === "string" ? value : "";
    const tokens = splitEmails(input);
    if (tokens.length <= 1) {
      setBccInputValue(input);
      return;
    }
    const validEmails = tokens.filter(isValidEmail);
    const invalidCount = tokens.length - validEmails.length;
    const seenEmails = new Set(
      bccSelectedItems.map((item) => item.email?.toLowerCase()).filter(Boolean)
    );
    const newItems = [];
    validEmails.forEach((rawEmail) => {
      const email = rawEmail.trim();
      const lowerEmail = email.toLowerCase();
      if (seenEmails.has(lowerEmail)) return;
      seenEmails.add(lowerEmail);
      const found = participantData2.find((item) => item.email?.toLowerCase() === lowerEmail);
      newItems.push(
        found ? standardizeObjectFormat(found) : { id: "", name: email, type: "Others", email }
      );
    });
    if (newItems.length) {
      const updated = [...bccSelectedItems, ...newItems];
      setBccSelectedItems(updated);
      setBccData(updated);
    }
    if (invalidCount > 0) {
      message.warning(`${invalidCount} invalid email${invalidCount > 1 ? "s" : ""} skipped`);
    }
    const invalidEmails = tokens.filter((email) => !isValidEmail(email));
    setTimeout(() => {
      setBccInputValue(invalidEmails.length ? invalidEmails.join(", ") : "");
      setBccOptions([]);
    }, 50);
  };
  // ---- end multi-email paste support helpers ----

  // ---- Drag & drop between To / Cc / Bcc helpers ----
  const DND_MIME = "application/x-recipient";

  const handleRecipientDragStart = (e, item, field) => {
    if (entity === "EntityPages" && field === "To") {
      e.preventDefault();
      return;
    }
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData(DND_MIME, JSON.stringify({ item, field }));
    setDraggingKey(`${field}:${item.email}`);

    // Browsers default to dragging a screenshot of the source element, which
    // looks messy for a styled chip. Swap in a small custom avatar+name pill.
    const preview = document.createElement("div");
    preview.style.cssText = `
      position: fixed;
      top: -1000px;
      left: -1000px;
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 14px 6px 6px;
      background: #ffffff;
      color: #1f2937;
      font-size: 12px;
      font-weight: 600;
      font-family: inherit;
      border-radius: 24px;
      white-space: nowrap;
      // box-shadow: 0 6px 16px rgba(31, 41, 55, 0.18), 0 0 0 1px rgba(65,131,241,0.25);
      pointer-events: none;
    `;
    const avatar = document.createElement("span");
    avatar.textContent = (item.name || "?").slice(0, 1).toUpperCase();
    avatar.style.cssText = `
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: linear-gradient(135deg, #4183f1, #6a5af9);
      color: #fff;
      font-size: 11px;
      font-weight: 700;
      flex-shrink: 0;
    `;
    const label = document.createElement("span");
    label.textContent = item.name;
    preview.appendChild(avatar);
    preview.appendChild(label);
    document.body.appendChild(preview);
    dragPreviewRef.current = preview;
    e.dataTransfer.setDragImage(preview, 18, 18);
  };

  const handleRecipientDragEnd = () => {
    if (dragPreviewRef.current) {
      document.body.removeChild(dragPreviewRef.current);
      dragPreviewRef.current = null;
    }
    setDraggingKey(null);
    setDragOverField(null);
  };

  const handleFieldDragOver = (e, field) => {
    if (entity === "EntityPages" && field === "To") {
      e.preventDefault();
      e.dataTransfer.dropEffect = "none";
      return;
    }
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
    if (dragOverField !== field) setDragOverField(field);
  };

  const handleFieldDragLeave = (e, field) => {
    // dragleave fires every time the pointer crosses onto a child element
    // (a chip, the input, the hint text) even while still inside the same
    // field, which caused the highlight to flicker on/off. Only clear the
    // state when the pointer has actually left the field's container.
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setDragOverField((prev) => (prev === field ? null : prev));
  };

  const dropZoneClass = (field) =>
    `gs-dropzone${dragOverField === field ? " gs-dropzone-active" : ""}`;

  const chipClass = (field, item) =>
    `share_image gs-chip${draggingKey === `${field}:${item.email}` ? " gs-chip-dragging" : ""}`;

  const moveRecipient = (item, fromField, toField) => {
    if (!item || fromField === toField) return;

    const getters = {
      To: {
        items: toSelectedItems,
        setItems: setToSelectedItems,
        setTags: (updated) => setState((prev) => ({ ...prev, tags: updated })),
        open: () => { },
      },
      Cc: {
        items: ccSelectedItems,
        setItems: setCcSelectedItems,
        setTags: setCcData,
        open: () => setCcOpen(true),
      },
      Bcc: {
        items: bccSelectedItems,
        setItems: setBccSelectedItems,
        setTags: setBccData,
        open: () => setBccOpen(true),
      },
    };

    const from = getters[fromField];
    const to = getters[toField];
    if (!from || !to) return;

    const remaining = from.items.filter((i) => i.email !== item.email);
    from.setItems(remaining);
    from.setTags(remaining);

    if (!to.items.some((i) => i.email === item.email)) {
      const updated = [...to.items, item];
      to.setItems(updated);
      to.setTags(updated);
      to.open();
    }
  };

  const handleFieldDrop = (e, toField) => {
    e.preventDefault();
    if (entity === "EntityPages" && toField === "To") {
      setDragOverField(null);
      return;
    }
    setDragOverField(null);
    const raw = e.dataTransfer.getData(DND_MIME);
    if (!raw) return;
    try {
      const { item, field: fromField } = JSON.parse(raw);
      moveRecipient(item, fromField, toField);
    } catch {
      // ignore malformed drag payloads
    }
  };
  // ---- end drag & drop helpers ----
  const normalizeValue1 = (value) => {
    if (value == null) return null;
    const trimmed = value?.trim?.();
    if (trimmed === "") return "";
    return trimmed ?? value;
  };
  const TohandleSearch = (value) => {
    setToInputValue(value);
    if (value) {
      const filteredOptions = participantData
        .filter(option =>
          normalizeValue1(option.name)?.toLowerCase().includes(normalizeValue1(value)?.toLowerCase())
          || normalizeValue1(option.email)?.toLowerCase().includes(normalizeValue1(value)?.toLowerCase())
        )
        .map((option, index) => ({
          value: index,
          data: option,
          label: (
            <div className='d-flex align-items-start'>
              <div className='diplay-center'>
                {option.name !== null && option.name !== undefined && option.name !== "" &&
                  <span className={`image_icon ${option.type === "Leads" ? "LeadIcon"
                    : option.type === "User" ? "UserIcon"
                      : option.type === "Contacts" ? "ContactIcon" : ""}`} style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}>
                    {option.name.slice(0, 1).toUpperCase()}
                  </span>
                }
              </div>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                <p style={{ margin: 0 }}>{option.email} ({option.type})</p>
              </div>
              <div className='div_last'>
                {toSelectedItems.some(item => JSON.stringify(standardizeObjectFormat(item)) === JSON.stringify(standardizeObjectFormat(option))) && (
                  <FeatherIcon icon="check" size={15} className="Svg" />
                )}
              </div>
            </div>
          ),
        }));
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (isValidEmail && !filteredOptions.some(option => option.data.email?.toLowerCase() === value?.toLowerCase())) {
        filteredOptions.push({
          value: filteredOptions.length,
          data: {
            id: "",
            name: value,
            email: value,
            type: "Others"
          },
          label: (
            <div className='d-flex align-items-start'>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{value}</p>
                <p style={{ margin: 0 }}>{value} (Others)</p>
              </div>
            </div>
          )
        });
      }
      setToOptions(filteredOptions);
    } else {
      setToOptions([]);
    }
  };
  const TohandleSelect = (index) => {
    const selectedItem = standardizeObjectFormat(toOptions[index].data);
    if (selectedItem) {
      const isSelected = toSelectedItems.some(item => JSON.stringify(item) === JSON.stringify(selectedItem));
      if (isSelected) {
        setToSelectedItems(toSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
        setState({ ...state, tags: toSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)) });
      } else {
        const newSelectedItems = [...toSelectedItems, selectedItem];
        setToSelectedItems(newSelectedItems);
        setState({ ...state, tags: newSelectedItems });
      }
      if (templateId?.id) {
        setSubject("")
        setTemplateId({ id: null, key: 0 })
        setContent("");
      }
      setToInputValue('');
      setToOptions([]);
    }
  };
  const TohandleDeselect = (items) => {
    const selectedItem = standardizeObjectFormat(items);
    setToSelectedItems(toSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
    setState({ ...state, tags: toSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)) });
  };
  const CchandleSearch = (value) => {
    setCcInputValue(value);
    if (value) {
      const filteredOptions = participantData2
        .filter(option =>
          option.name.toLowerCase().includes(value.toLowerCase())
          || option.email.toLowerCase().includes(value.toLowerCase())
        )
        .map((option, index) => ({
          value: index,
          data: option,
          label: (
            <div className='d-flex align-items-start'>
              <div className='diplay-center'>
                {option.name !== null && option.name !== undefined && option.name !== "" &&
                  <span className={`image_icon ${option.type === "Leads" ? "LeadIcon"
                    : option.type === "User" ? "UserIcon"
                      : option.type === "Contacts" ? "ContactIcon" : ""}`} style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}>
                    {option.name.slice(0, 1).toUpperCase()}
                  </span>
                }
              </div>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                <p style={{ margin: 0 }}>{option.email} ({option.type})</p>
              </div>
              <div className='div_last'>
                {ccSelectedItems.some(item => JSON.stringify(standardizeObjectFormat(item)) === JSON.stringify(standardizeObjectFormat(option))) && (
                  <FeatherIcon icon="check" size={15} className="Svg" />
                )}
              </div>
            </div>
          ),
        }));
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (isValidEmail && !filteredOptions.some(option => option.data.email?.toLowerCase() === value?.toLowerCase())) {
        filteredOptions.push({
          value: filteredOptions.length,
          data: {
            id: "",
            name: value,
            email: value,
            type: "Others"
          },
          label: (
            <div className='d-flex align-items-start'>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{value}</p>
                <p style={{ margin: 0 }}>{value} (Others)</p>
              </div>
            </div>
          )
        });
      }
      setCcOptions(filteredOptions);
    } else {
      setCcOptions([]);
    }
  };
  const CchandleSelect = (index) => {
    const selectedItem = standardizeObjectFormat(ccOptions[index].data);
    if (selectedItem) {
      const isSelected = ccSelectedItems.some(item => JSON.stringify(item) === JSON.stringify(selectedItem));
      if (isSelected) {
        setCcSelectedItems(ccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
        setCcData(ccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
      } else {
        const newSelectedItems = [...ccSelectedItems, selectedItem];
        setCcSelectedItems(newSelectedItems);
        setCcData(newSelectedItems);
      }
      setCcInputValue('');
      setCcOptions([]);
    }
  };
  const CchandleDeselect = (items) => {
    const selectedItem = standardizeObjectFormat(items);
    setCcSelectedItems(ccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
    setCcData(ccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
  };
  const setCcClose = () => {
    setCcOpen(false)
    setCcInputValue('');
    setCcOptions([]);
    setCcData([])
    setCcSelectedItems([])
  }
  const BcchandleSearch = (value) => {
    setBccInputValue(value);
    if (value) {
      const filteredOptions = participantData2
        .filter(option =>
          option.name.toLowerCase().includes(value.toLowerCase())
          || option.email.toLowerCase().includes(value.toLowerCase())
        )
        .map((option, index) => ({
          value: index,
          data: option,
          label: (
            <div className='d-flex align-items-start'>
              <div className='diplay-center'>
                {option.name !== null && option.name !== undefined && option.name !== "" &&
                  <span className={`image_icon ${option.type === "Leads" ? "LeadIcon"
                    : option.type === "User" ? "UserIcon"
                      : option.type === "Contacts" ? "ContactIcon" : ""}`} style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: 15 }}>
                    {option.name.slice(0, 1).toUpperCase()}
                  </span>
                }
              </div>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.name}</p>
                <p style={{ margin: 0 }}>{option.email} ({option.type})</p>
              </div>
              <div className='div_last'>
                {bccSelectedItems.some(item => JSON.stringify(standardizeObjectFormat(item)) === JSON.stringify(standardizeObjectFormat(option))) && (
                  <FeatherIcon icon="check" size={15} className="Svg" />
                )}
              </div>
            </div>
          ),
        }));
      const isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      if (isValidEmail && !filteredOptions.some(option => option.data.email?.toLowerCase() === value?.toLowerCase())) {
        filteredOptions.push({
          value: filteredOptions.length,
          data: {
            id: "",
            name: value,
            email: value,
            type: "Others"
          },
          label: (
            <div className='d-flex align-items-start'>
              <div>
                <p style={{ fontWeight: 'bold', margin: 0 }}>{value}</p>
                <p style={{ margin: 0 }}>{value} (Others)</p>
              </div>
            </div>
          )
        });
      }
      setBccOptions(filteredOptions);
    } else {
      setBccOptions([]);
    }
  };
  const BcchandleSelect = (index) => {
    const selectedItem = standardizeObjectFormat(bccOptions[index].data);
    if (selectedItem) {
      const isSelected = bccSelectedItems.some(item => JSON.stringify(item) === JSON.stringify(selectedItem));
      if (isSelected) {
        setBccSelectedItems(bccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
        setBccData(bccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
      } else {
        const newSelectedItems = [...bccSelectedItems, selectedItem];
        setBccSelectedItems(newSelectedItems);
        setBccData(newSelectedItems);
      }
      setBccInputValue('');
      setBccOptions([]);
    }
  };
  const BcchandleDeselect = (items) => {
    const selectedItem = standardizeObjectFormat(items);
    setBccSelectedItems(bccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
    setBccData(bccSelectedItems.filter(item => JSON.stringify(item) !== JSON.stringify(selectedItem)));
  };
  const setBccClose = () => {
    setBccOpen(false)
    setBccInputValue('');
    setBccOptions([]);
    setBccData([])
    setBccSelectedItems([])
  }
  const downloadAttachment = (attachment) => {
    const blob = new Blob([new Uint8Array(attachment.content.data)], { type: attachment.contentType });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = attachment.filename;
    link.click();
    URL.revokeObjectURL(link.href);
  };
  const removeRow = async (index) => {
    const updatedFormData = [...files];
    updatedFormData.splice(index, 1);
    setFiles(updatedFormData);
  }
  const shortenFilename = (filename, maxLength = 20) => {
    const extension = filename.substring(filename.lastIndexOf('.'));
    const nameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'));
    if (nameWithoutExtension.length > maxLength) {
      return `${nameWithoutExtension.substring(0, maxLength)}...${extension}`;
    }
    return filename;
  };
  useEffect(() => {
    if (mailOpen) {
      setParticipantData2([])
      setParticipantData([])
      getPartcipants()
    }
  }, [entityName, mailOpen])
  useEffect(() => {
    if (mailOpen) {
      if (replyToPopup === "DraftDetail") {
        if (forwardformat) {
          if (forwardformat?.to.length > 0) {
            const toData = forwardformat.to?.map((item) => (item.address || item.email)).join(", ")
            const emailArray = toData.split(',').map(email => email.trim())
            const processedUsers = processEmails(emailArray);
            setState({ ...state, tags: processedUsers });
            setToSelectedItems(processedUsers)
          }
          else {
            setState({ ...state, tags: [] });
            setToSelectedItems([])
          }
          if (forwardformat?.cc.length > 0) {
            const ccData = forwardformat.cc?.map((item) => (item.address || item.email)).join(", ")
            const emailArray = ccData.split(',').map(email => email.trim())
            const processedUsers = processEmails2(emailArray);
            setCcData(processedUsers);
            setCcSelectedItems(processedUsers)
          }
          else {
            setCcData([]);
            setCcSelectedItems([]);
          }
          if (forwardformat?.bcc.length > 0) {
            const bccData = forwardformat.bcc?.map((item) => (item.address || item.email)).join(", ")
            const emailArray = bccData.split(',').map(email => email.trim())
            const processedUsers = processEmails2(emailArray);
            setBccData(processedUsers);
            setBccSelectedItems(processedUsers)
          }
          else {
            setBccData([]);
            setBccSelectedItems([]);
          }
        }
      }
      else if (replyToPopup === "Reply To") {
        if (forwardformat) {
          let replayids;
          if (detailsPage === 'INBOX' || detailsPage === 'Trash' || detailsPage === 'Spam') {
            const emailArray = forwardformat.from.address.split(',').map(email => email.trim())
            replayids = emailArray
          } else if (detailsPage === 'Sent' || detailsPage === 'BulkEMail') {
            const toData = forwardformat.to?.map((item) => (item.address || item.email)).join(", ")
            const emailArray = toData.split(',').map(email => email.trim())
            replayids = emailArray;
          }
          const newUserList = replayids.map(replayid => {
            let userData = participantData.find(item => item.email === replayid);
            if (!userData) {
              userData = {
                id: "",
                name: replayid,
                type: "Others",
                email: replayid,
              };
            }
            else {
              userData = {
                id: userData.id,
                name: userData.name,
                type: userData.type,
                email: userData.email,
              };
            }
            return userData;
          });
          setState({ ...state, tags: newUserList })
          setToSelectedItems(newUserList)
        }
      }
      else if (replyToPopup === "Reply All") {
        if (forwardformat) {
          const loginEmail = emailapiValues.email?.toLowerCase();
          const replayids = [];
          const replayids1 = [];
          if (detailsPage === 'INBOX' || detailsPage === 'Spam') {
            replayids.push(
              ...forwardformat.from?.address
                ?.split(',')
                .map(e => e.trim()) || []
            );
            const otherToRecipients = forwardformat.to
              ?.map(item => item.address || item.email)
              .filter(email => email && email.toLowerCase() !== loginEmail) || [];
            replayids1.push(...otherToRecipients);
          } else if (detailsPage === 'Sent' || detailsPage === "Bulk Email" || detailsPage === "Approval Email" || detailsPage === "Automation Email" || detailsPage === "Outreah") {
            const toData = forwardformat.to?.map((item) => (item.address || item.email)).join(", ")
            replayids.push(...toData.split(',').map(e => e.trim()).filter(Boolean));
          }
          else if (detailsPage === 'Trash') {
            const fromEmail = forwardformat.from?.address?.toLowerCase();
            if (fromEmail === loginEmail) {
              const toData = forwardformat.to
                ?.map(item => item.address || item.email)
                .join(", ");
              replayids.push(...toData.split(',').map(e => e.trim()).filter(Boolean));
            } else {
              replayids.push(fromEmail);
            }
          }
          const ccData = forwardformat.cc?.map((item) => (item.address || item.email)).join(", ") || "";
          replayids1.push(...ccData.split(',').map(email => email.trim()).filter(Boolean));
          if (replayids?.length > 0) {
            const uniqueReplayIds = [
              ...new Set(
                replayids.filter(
                  email => email && email.toLowerCase() !== loginEmail
                )
              )
            ];
            const newUserList = uniqueReplayIds.map(replayid => {
              let userData = participantData.find(item => item.email === replayid);
              if (!userData) {
                userData = {
                  id: "",
                  name: replayid,
                  type: "Others",
                  email: replayid,
                };
              }
              else {
                userData = {
                  id: userData.id,
                  name: userData.name,
                  type: userData.type,
                  email: userData.email,
                };
              }
              return userData;
            });
            setState({ ...state, tags: newUserList })
            setToSelectedItems(newUserList)
          } else {
            setState({ ...state, tags: [] });
            setToSelectedItems([])
          }
          if (replayids1?.length > 0) {
            const uniqueReplayIds = [
              ...new Set(
                replayids1.filter(
                  email => email && email.toLowerCase() !== loginEmail
                )
              )
            ];
            const newUserList = uniqueReplayIds.map(replayid => {
              let userData = participantData.find(item => item.email === replayid);
              if (!userData) {
                userData = {
                  id: "",
                  name: replayid,
                  type: "Others",
                  email: replayid,
                };
              }
              else {
                userData = {
                  id: userData.id,
                  name: userData.name,
                  type: userData.type,
                  email: userData.email,
                };
              }
              return userData;
            });
            setCcData(newUserList);
            setCcSelectedItems(newUserList)
            setCcOpen(true)
          }
          else {
            setCcOpen(false)
            setCcData([]);
            setCcSelectedItems([]);
          }
        }
      }
      else {
        // eslint-disable-next-line no-lonely-if
        if (participantData.length > 0 && toId) {
          const processedUsers = Emailsarray(toId);
          setState({ ...state, tags: processedUsers });
          setToSelectedItems(processedUsers)
        }
      }
    }
  }, [replyToPopup, forwardformat, participantData, toId, participantData2, mailOpen])
  useEffect(() => {
    if (toSelectedItems.length > 0) {
      setEntityId(toSelectedItems[0].id)
    } else {
      setEntityId()
    }
  }, [toSelectedItems])
  const showConfirm = (id) => {
    const hasSubject = subject !== undefined && subject !== null && subject !== "";
    const hasRecipients = Array.isArray(toSelectedItems) && toSelectedItems.length > 0;
    let title;
    let content;
    let okText;
    let cancelText;
    let showCancel;
    let onOkHandler;
    let onCancelHandler;
    if (!hasRecipients) {
      title = (
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
          <span>No Recipients</span>
        </div>
      );
      content = <p>Please add at least one recipient before sending this message.</p>;
      okText = "OK";
      cancelText = null;
      showCancel = false;
      onOkHandler = (modalInstance) => modalInstance.destroy();
      onCancelHandler = null;
    }
    else if (!hasSubject) {
      title = (
        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
          <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
          <span>Missing subject</span>
        </div>
      );
      content = <p>Do you want to send this message without a subject?</p>;
      okText = "Don't send";
      cancelText = "Send";
      showCancel = true;
      onOkHandler = (modalInstance) => modalInstance.destroy();
      onCancelHandler = () => onEmailSend(id);
    }
    else {
      return onEmailSend(id);
    }
    const modalInstance = Modal.confirm({
      title,
      icon: null,
      className: "customice-confirm-modal",
      content,
      centered: true,
      okText,
      cancelText,
      okButtonProps: { className: "gray-buttonModal" },
      cancelButtonProps: { className: "button_colorsModal" },
      okCancel: showCancel,
      onOk: () => onOkHandler(modalInstance),
      onCancel: onCancelHandler,
    });
  };
  // const showConfirm1 = (id, value) => {
  //   const hasSubject = subject !== undefined && subject !== null && subject !== "";
  //   const hasRecipients = Array.isArray(toSelectedItems) && toSelectedItems.length > 0;
  //   let title;
  //   let content;
  //   let okText;
  //   let cancelText;
  //   let showCancel;
  //   let onOkHandler;
  //   let onCancelHandler;
  //   if (!hasRecipients) {
  //     title = (
  //       <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
  //         <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
  //         <span>No Recipients</span>
  //       </div>
  //     );
  //     content = <p>Please add at least one recipient before saving this message.</p>;
  //     okText = "OK";
  //     cancelText = null;
  //     showCancel = false;
  //     onOkHandler = (modalInstance) => modalInstance.destroy();
  //     onCancelHandler = null;
  //   }
  //   else if (!hasSubject) {
  //     title = (
  //       <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
  //         <ExclamationCircleOutlined style={{ color: '#f28e42', fontSize: 20 }} />
  //         <span>Missing subject</span>
  //       </div>
  //     );
  //     content = <p>Do you want to save this message without a subject?</p>;
  //     okText = "Cancel";
  //     cancelText = "Save";
  //     showCancel = true;
  //     onOkHandler = (modalInstance) => modalInstance.destroy();
  //     onCancelHandler = () => onDraftSend(id, value);
  //   }
  //   else {
  //     return onDraftSend(id, value);
  //   }
  //   const modalInstance = Modal.confirm({
  //     title,
  //     icon: null,
  //     className: "customice-confirm-modal",
  //     content,
  //     centered: true,
  //     okText,
  //     cancelText,
  //     okButtonProps: { className: "gray-buttonModal" },
  //     cancelButtonProps: { className: "button_colorsModal" },
  //     okCancel: showCancel,
  //     onOk: () => onOkHandler(modalInstance),
  //     onCancel: onCancelHandler,
  //   });
  // };
  const SubjectNameCheck = (id) => {
    if (subject !== undefined && subject !== null && subject !== "" && toSelectedItems?.length) {
      if (aiContent && aiCompose) {
        setShowAiDraftConfirm(true);
      } else {
        onEmailSend(id);
      }
    } else {
      showConfirm(id)
    }
  }
  const SubjectNameCheck1 = (id, value) => {
    if (toSelectedItems?.length) { // subject !== undefined && subject !== null && subject !== "" && 
      onDraftSend(id, value)
      // } else {
      //   showConfirm1(id, value)
    }
  }
  async function AiDraftCall() {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setDoubleClick2(true)
    try {
      const DraftSubject = subject;
      const Draftcontent = content;
      const payload = {
        tone: "Professional",
        subject: normalizeValue(DraftSubject),
        context: Draftcontent,
        toAddress: state.tags,
        signature: `<div id="signature-block-unique" contenteditable='true' style="margin-top: 20px;">
    ${profile?.profileSignature || "<div>Add signature</div>"}
  </div>`,
      }
      const response = await AIDefatMessage(companyProfile.companyId, payload)
      const rawContent = response?.choices?.[0]?.message?.content || "";
      const match = rawContent.match(/```html([\s\S]*?)(```|$)/);
      const htmlContent = match ? match[1].trim() : rawContent.trim();
      const convertedHtml = replacePTagsWithDiv(htmlContent);
      setAiContent(convertedHtml)
      loadingRef.current = false;
      setDoubleClick2(false)
    }
    catch (error) {
      loadingRef.current = false;
      setDoubleClick2(false)
      setAiContent("");
      message.error(error)
    }
  }
  const AiContentCall = () => {
    setAiContent()
    setAiCompose(true)
    toggleSize(1200)
    AiDraftCall()
  }
  const onAiclose = () => {
    setAiContent()
    setAiCompose(false)
    toggleSize(600)
  }
  const MergeAiContent = () => {
    if (!aiContent) return;
    const parser = new DOMParser();
    const doc = parser.parseFromString(content || "<div><br></div>", "text/html");
    const nonEditable = doc.querySelector("div[contenteditable='false']");
    if (nonEditable) {
      let node = doc.body.firstChild;
      while (node && node !== nonEditable) {
        const next = node.nextSibling;
        node.remove();
        node = next;
      }
      nonEditable.insertAdjacentHTML("beforebegin", aiContent);
      setContent(doc.body.innerHTML);
    } else {
      setContent(aiContent)
    }
    onAiclose();
  };

  const handleAiDraftConfirm = () => {
    setShowAiDraftConfirm(false);
    setAiContent();
    setAiCompose(false);
    toggleSize(600);
    onEmailSend(mailSaveId);
  };

  const handleAiDraftCancel = () => {
    setShowAiDraftConfirm(false);
  };
  const SIGNATURE_ID = "signature-block-unique";
  const hasSignature = content?.includes(`id="${SIGNATURE_ID}"`);
  const handleAddSignature = () => {
    setContent((prevContent) => {
      const identifier = "signature-block-unique";

      const signatureHtml = `<div id="${identifier}">
      ${profile?.profileSignature || "<div>Add signature</div>"}
    </div>`;
      const spacerDivs = `<div>&nbsp;</div><div>&nbsp;</div>`;

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = prevContent;
      const existingSignature = tempDiv.querySelector(`#${identifier}`);

      if (existingSignature) {
        existingSignature.outerHTML = signatureHtml;
        return tempDiv.innerHTML;
      }
      const replyBlock = tempDiv.querySelector("#ReplyContent");
      const forwardBlock = tempDiv.querySelector("#ForwardContent");

      if (replyBlock || forwardBlock) {
        const targetBlock = replyBlock || forwardBlock;

        const wrapper = document.createElement('div');
        wrapper.innerHTML = `${spacerDivs}${signatureHtml}`;
        targetBlock.parentNode.insertBefore(wrapper, targetBlock);

        return tempDiv.innerHTML;
      }
      const contentToAdd = prevContent.trim() === ""
        ? prevContent.trim() + spacerDivs
        : prevContent.trim();
      return `${contentToAdd.trim()}${signatureHtml}`;
    });
  };
  const handleRemoveSignature = () => {
    setContent((prevContent) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = prevContent;

      const signature = tempDiv.querySelector("#signature-block-unique");

      if (signature) {
        signature.remove();
      }

      return tempDiv.innerHTML;
    });
  };
  return (
    <>
      <style>{`
        .gs-chip {
          transition: transform 0.15s ease, box-shadow 0.15s ease, opacity 0.15s ease;
          cursor: grab;
        }
        .gs-chip:hover {
          transform: translateY(-1px);
          box-shadow: 0 3px 8px rgba(65, 131, 241, 0.22);
        }
        .gs-chip:active {
          cursor: grabbing;
        }
        .gs-chip-dragging {
          opacity: 0.35;
          transform: scale(0.94);
        }
        .gs-dropzone {
          position: relative;
        }
        .gs-dropzone-hint {
          display: none;
          align-items: center;
          gap: 6px;
          font-size: 11px;
          font-weight: 600;
          color: #4183f1;
          margin-bottom: 6px;
        }
        .gs-dropzone-active .gs-dropzone-hint {
          display: flex;
          animation: gs-fade-in 0.15s ease forwards;
        }
        @keyframes gs-fade-in {
          from { opacity: 0; transform: translateY(-3px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <Drawer
        className='Drawer-Header-Pages'
        bodyStyle={{ padding: 0 }}
        closable={false}
        placement="right"
        width={composeSize}
        open={mailOpen}
        title="Email"
        extra={
          <Space>
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              {!aiCompose ?
                (composeSize === 600 ?
                  <FeatherIcon onClick={() => toggleSize(1200)} icon="maximize-2" size={20} style={{ cursor: "pointer" }} /> :
                  <FeatherIcon onClick={() => toggleSize(600)} icon="minimize-2" size={20} style={{ cursor: "pointer" }} />) : ""}
              <FeatherIcon onClick={() => onclose(mailSaveId, "Close")} icon="x" size={20} style={{ cursor: "pointer" }} />
            </div>
          </Space >
        }
        footer={[
          <div style={{ display: "flex", alignItems: 'center', justifyContent: "space-between" }}>
            <div className="form_action_button">
              <Button size="small" raised className="gradient-button" onClick={() => AiContentCall()}
                disabled={disabled || doubleClick2 || (subject === undefined || subject === null || subject === "") || (content === undefined || content === null || content === "" || content === "<br>")} loading={doubleClick2}>
                {!doubleClick2 && <AiIcon />}Generate Draft
              </Button>
            </div>
            <div className="form_action_button">
              <Button size="small" onClick={() => onclose(mailSaveId, "DraftMail")} raised className="gray-button" disabled={disabled}>
                <FeatherIcon icon="trash-2" />Discard
              </Button>
              <Button size="small" onClick={() => SubjectNameCheck1(mailSaveId, "Save")} raised className="button_colors" disabled={disabled || doubleClick1} loading={doubleClick1}>
                {!doubleClick1 && <FeatherIcon icon="save" />}Save
              </Button>
              <Button size="small" onClick={() => SubjectNameCheck(mailSaveId)} raised className="button_colors" disabled={disabled || doubleClick} loading={doubleClick}>
                {!doubleClick && <FeatherIcon icon="send" />}Send
              </Button>
            </div>
          </div>
        ]}
      >
        <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
          <div style={{ margin: window.innerWidth <= 991 ? "12px 16px" : "20px 40px" }}>
            <MailBox2>
              <div className="body email-body" style={{ display: "flex", flexDirection: window.innerWidth <= 991 ? "column" : "row", justifyContent: "space-between" }}>
                <div style={{ width: aiCompose && window.innerWidth > 991 ? "50%" : "100%" }}>
                  {(typeOfPge === "DraftDetail" &&
                    !forwardformat) ?
                    <div className="spin">
                      <Spin />
                    </div> :
                    <div className="body">
                      <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                          <div
                            className={`reply-inner ${dropZoneClass("To")}`}
                            onDragOver={(e) => handleFieldDragOver(e, "To")}
                            onDragLeave={(e) => handleFieldDragLeave(e, "To")}
                            onDrop={(e) => handleFieldDrop(e, "To")}
                          >
                            <div className="gs-dropzone-hint">
                              <FeatherIcon icon="corner-down-left" size={12} />
                              Drop to move to To
                            </div>
                            {toSelectedItems.length > 0 && toSelectedItems[0] &&
                              <div className='Div_flex' style={{ alignItems: 'flex-start' }}>
                                {showAllTo ? (
                                  <Scrollbars
                                    // autoHide
                                    // autoHideTimeout={500}
                                    // autoHideDuration={200}
                                    autoHeight
                                    autoHeightMin={0}
                                    autoHeightMax={120}
                                    style={{ width: "100%" }}
                                  >
                                    <div className='Div_flex' style={{ flexWrap: 'wrap', paddingRight: 10 }}>
                                      {toSelectedItems.map((item, index) => (
                                        <div
                                          className={entity !== "EntityPages" ? chipClass("To", item) : "share_image"}
                                          key={index}
                                          title={`${item.name} (${item.type})`}
                                          draggable={entity !== "EntityPages"}
                                          onDragStart={(e) => handleRecipientDragStart(e, item, "To")}
                                          onDragEnd={handleRecipientDragEnd}
                                        >
                                          <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                            : item.type === "User" ? "UserIcon"
                                              : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                            {item.name.slice(0, 1).toUpperCase()}
                                          </span>
                                          <span>{`${item.name.substring(0, 10)}...`}</span>
                                          {(entity !== "EntityPages" && edit) && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => TohandleDeselect(item)} />}
                                        </div>
                                      ))}
                                      <div className='share_image' role="button" tabIndex={0}
                                        style={{ cursor: "pointer", background: "#f0f0f0", color: "black", padding: "0px 5px" }}
                                        onClick={() => setShowAllTo(false)}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowAllTo(false) }}>
                                        Show less
                                      </div>
                                    </div>
                                  </Scrollbars>
                                ) : (
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <div
                                      ref={toOverflow.measureRef}
                                      aria-hidden="true"
                                      style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 6,
                                        width: '100%',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        visibility: 'hidden',
                                        pointerEvents: 'none',
                                      }}
                                    >
                                      {toSelectedItems.map((item, index) => (
                                        <div className={entity !== "EntityPages" ? chipClass("To", item) : "share_image"} key={index}>
                                          <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                            : item.type === "User" ? "UserIcon"
                                              : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                            {item.name.slice(0, 1).toUpperCase()}
                                          </span>
                                          <span>{`${item.name.substring(0, 10)}...`}</span>
                                          {(entity !== "EntityPages" && edit) && <FeatherIcon icon="x" size={15} className="Svg" />}
                                        </div>
                                      ))}
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, width: "100%" }}>
                                      {toSelectedItems
                                        .slice(0, toOverflow.visibleCount === null ? toSelectedItems.length : toOverflow.visibleCount)
                                        .map((item, index) => (
                                          <div
                                            className={entity !== "EntityPages" ? chipClass("To", item) : "share_image"}
                                            key={index}
                                            title={`${item.name} (${item.type})`}
                                            draggable={entity !== "EntityPages"}
                                            onDragStart={(e) => handleRecipientDragStart(e, item, "To")}
                                            onDragEnd={handleRecipientDragEnd}
                                          >
                                            <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                              : item.type === "User" ? "UserIcon"
                                                : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                              {item.name.slice(0, 1).toUpperCase()}
                                            </span>
                                            <span>{`${item.name.substring(0, 10)}...`}</span>
                                            {(entity !== "EntityPages" && edit) && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => TohandleDeselect(item)} />}
                                          </div>
                                        ))}
                                      {toOverflow.hasOverflow && (
                                        <div className='share_image' role="button" tabIndex={0}
                                          style={{ cursor: "pointer", background: "#f0f0f0", color: "black", padding: "0px 5px" }}
                                          onClick={() => setShowAllTo(true)}
                                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowAllTo(true) }}>
                                          +{toSelectedItems.length - toOverflow.visibleCount} more
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>}
                            <TopToolBoxClone3 style={{ display: "flex", alignItems: "center" }}>
                              {entity === "EntityPages" ?
                                <div style={{ width: "100%", maxWidth: CcOpen || BccOpen ? "100%" : "90%", padding: "10px 0px" }}>
                                  To
                                </div>
                                : <AutoComplete
                                  style={{ width: "100%", maxWidth: CcOpen || BccOpen ? "100%" : "90%" }}
                                  onSearch={TohandleSearch}
                                  onSelect={TohandleSelect}
                                  options={toOptions}
                                  value={toInputValue}
                                  onChange={handleToChange}
                                >
                                  <Input placeholder={replyToPopup === "Reply To" ? "To" : 'To'} />
                                </AutoComplete>}
                              <div className="mail-cc" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px", marginTop: 10 }}>
                                {CcOpen || BccOpen ? <></> :
                                  <><span className="Email-CcBcc" role="button"
                                    tabIndex={0}
                                    onClick={handleCcOpen}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        handleCcOpen()
                                      }
                                    }}>Cc</span>
                                    <span className="Email-CcBcc" role="button"
                                      tabIndex={0}
                                      onClick={handleBccOpen}
                                      onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                          handleBccOpen()
                                        }
                                      }}>Bcc</span>
                                  </>
                                }
                              </div>
                            </TopToolBoxClone3>
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>
                      {CcOpen && <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} >
                          <div
                            className={`reply-inner ${dropZoneClass("Cc")}`}
                            onDragOver={(e) => handleFieldDragOver(e, "Cc")}
                            onDragLeave={(e) => handleFieldDragLeave(e, "Cc")}
                            onDrop={(e) => handleFieldDrop(e, "Cc")}
                          >
                            <div className="gs-dropzone-hint">
                              <FeatherIcon icon="corner-down-left" size={12} />
                              Drop to move to Cc
                            </div>
                            {ccSelectedItems.length > 0 &&
                              <div className='Div_flex' style={{ alignItems: 'flex-start' }}>
                                {showAllCc ? (
                                  <Scrollbars
                                    // autoHide
                                    // autoHideTimeout={500}
                                    // autoHideDuration={200}
                                    autoHeight
                                    autoHeightMin={0}
                                    autoHeightMax={120}
                                    style={{ width: "100%" }}
                                  >
                                    <div className='Div_flex' style={{ flexWrap: 'wrap', paddingRight: 10 }}>
                                      {ccSelectedItems.map((item, index) => (
                                        <div
                                          className={chipClass("Cc", item)}
                                          key={index}
                                          title={`${item.name} (${item.type})`}
                                          draggable
                                          onDragStart={(e) => handleRecipientDragStart(e, item, "Cc")}
                                          onDragEnd={handleRecipientDragEnd}
                                        >
                                          <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                            : item.type === "User" ? "UserIcon"
                                              : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                            {item.name.slice(0, 1).toUpperCase()}
                                          </span>
                                          <span>{`${item.name.substring(0, 10)}...`}</span>
                                          {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => CchandleDeselect(item)} />}
                                        </div>
                                      ))}
                                      <div className='share_image' role="button" tabIndex={0}
                                        style={{ cursor: "pointer", background: "#f0f0f0", color: "black", padding: "0px 5px" }}
                                        onClick={() => setShowAllCc(false)}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowAllCc(false) }}>
                                        Show less
                                      </div>
                                    </div>
                                  </Scrollbars>
                                ) : (
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <div
                                      ref={ccOverflow.measureRef}
                                      aria-hidden="true"
                                      style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 6,
                                        width: '100%',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        visibility: 'hidden',
                                        pointerEvents: 'none',
                                      }}
                                    >
                                      {ccSelectedItems.map((item, index) => (
                                        <div className={chipClass("Cc", item)} key={index}>
                                          <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                            : item.type === "User" ? "UserIcon"
                                              : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                            {item.name.slice(0, 1).toUpperCase()}
                                          </span>
                                          <span>{`${item.name.substring(0, 10)}...`}</span>
                                          {edit && <FeatherIcon icon="x" size={15} className="Svg" />}
                                        </div>
                                      ))}
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, width: "100%" }}>
                                      {ccSelectedItems
                                        .slice(0, ccOverflow.visibleCount === null ? ccSelectedItems.length : ccOverflow.visibleCount)
                                        .map((item, index) => (
                                          <div
                                            className={chipClass("Cc", item)}
                                            key={index}
                                            title={`${item.name} (${item.type})`}
                                            draggable
                                            onDragStart={(e) => handleRecipientDragStart(e, item, "Cc")}
                                            onDragEnd={handleRecipientDragEnd}
                                          >
                                            <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                              : item.type === "User" ? "UserIcon"
                                                : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                              {item.name.slice(0, 1).toUpperCase()}
                                            </span>
                                            <span>{`${item.name.substring(0, 10)}...`}</span>
                                            {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => CchandleDeselect(item)} />}
                                          </div>
                                        ))}
                                      {ccOverflow.hasOverflow && (
                                        <div className='share_image' role="button" tabIndex={0}
                                          style={{ cursor: "pointer", background: "#f0f0f0", color: "black", padding: "0px 5px" }}
                                          onClick={() => setShowAllCc(true)}
                                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowAllCc(true) }}>
                                          +{ccSelectedItems.length - ccOverflow.visibleCount} more
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}</div>
                            }
                            <TopToolBoxClone3 style={{ display: "flex", alignItems: "center" }}>
                              <AutoComplete
                                style={{ width: "90%" }}
                                onSearch={CchandleSearch}
                                onSelect={CchandleSelect}
                                options={ccOptions}
                                value={ccInputValue}
                                onChange={handleCcPaste}
                              >
                                <Input placeholder='Cc' />
                              </AutoComplete>
                              <div className="mail-cc" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px", marginTop: 10 }}>
                                {BccOpen ? <></> : <span className="Email-CcBcc" role="button"
                                  tabIndex={0}
                                  onClick={handleBccOpen}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      handleBccOpen()
                                    }
                                  }}>Bcc</span>}
                                <span className="Email-CcBcc" role="button"
                                  tabIndex={0}
                                  onClick={() => setCcClose()}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      setCcClose()
                                    }
                                  }}><s>Cc</s></span>
                              </div>
                            </TopToolBoxClone3>
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>}
                      {BccOpen && <div className="group">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div
                            className={`reply-inner ${dropZoneClass("Bcc")}`}
                            onDragOver={(e) => handleFieldDragOver(e, "Bcc")}
                            onDragLeave={(e) => handleFieldDragLeave(e, "Bcc")}
                            onDrop={(e) => handleFieldDrop(e, "Bcc")}
                          >
                            <div className="gs-dropzone-hint">
                              <FeatherIcon icon="corner-down-left" size={12} />
                              Drop to move to Bcc
                            </div>
                            {bccSelectedItems.length > 0 &&
                              <div className='Div_flex' style={{ alignItems: 'flex-start' }}>
                                {showAllBcc ? (
                                  <Scrollbars
                                    // autoHide
                                    // autoHideTimeout={500}
                                    // autoHideDuration={200}
                                    autoHeight
                                    autoHeightMin={0}
                                    autoHeightMax={120}
                                    style={{ width: "100%" }}
                                  >
                                    <div className='Div_flex' style={{ flexWrap: 'wrap', paddingRight: 10 }}>
                                      {bccSelectedItems.map((item, index) => (
                                        <div
                                          className={chipClass("Bcc", item)}
                                          key={index}
                                          title={`${item.name} (${item.type})`}
                                          draggable
                                          onDragStart={(e) => handleRecipientDragStart(e, item, "Bcc")}
                                          onDragEnd={handleRecipientDragEnd}
                                        >
                                          <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                            : item.type === "User" ? "UserIcon"
                                              : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                            {item.name.slice(0, 1).toUpperCase()}
                                          </span>
                                          <span>{`${item.name.substring(0, 10)}...`}</span>
                                          {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => BcchandleDeselect(item)} />}
                                        </div>
                                      ))}
                                      <div className='share_image' role="button" tabIndex={0}
                                        style={{ cursor: "pointer", background: "#f0f0f0", color: "black", padding: "0px 5px" }}
                                        onClick={() => setShowAllBcc(false)}
                                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowAllBcc(false) }}>
                                        Show less
                                      </div>
                                    </div>
                                  </Scrollbars>
                                ) : (
                                  <div style={{ position: 'relative', width: '100%' }}>
                                    <div
                                      ref={bccOverflow.measureRef}
                                      aria-hidden="true"
                                      style={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        gap: 6,
                                        width: '100%',
                                        position: 'absolute',
                                        top: 0,
                                        left: 0,
                                        visibility: 'hidden',
                                        pointerEvents: 'none',
                                      }}
                                    >
                                      {bccSelectedItems.map((item, index) => (
                                        <div className={chipClass("Bcc", item)} key={index}>
                                          <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                            : item.type === "User" ? "UserIcon"
                                              : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                            {item.name.slice(0, 1).toUpperCase()}
                                          </span>
                                          <span>{`${item.name.substring(0, 10)}...`}</span>
                                          {edit && <FeatherIcon icon="x" size={15} className="Svg" />}
                                        </div>
                                      ))}
                                    </div>
                                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, width: "100%" }}>
                                      {bccSelectedItems
                                        .slice(0, bccOverflow.visibleCount === null ? bccSelectedItems.length : bccOverflow.visibleCount)
                                        .map((item, index) => (
                                          <div
                                            className={chipClass("Bcc", item)}
                                            key={index}
                                            title={`${item.name} (${item.type})`}
                                            draggable
                                            onDragStart={(e) => handleRecipientDragStart(e, item, "Bcc")}
                                            onDragEnd={handleRecipientDragEnd}
                                          >
                                            <span className={`image_icon2 ${item.type === "Leads" ? "LeadIcon"
                                              : item.type === "User" ? "UserIcon"
                                                : item.type === "Contacts" ? "ContactIcon" : ""}`}>
                                              {item.name.slice(0, 1).toUpperCase()}
                                            </span>
                                            <span>{`${item.name.substring(0, 10)}...`}</span>
                                            {edit && <FeatherIcon icon="x" size={15} className="Svg" onClick={() => BcchandleDeselect(item)} />}
                                          </div>
                                        ))}
                                      {bccOverflow.hasOverflow && (
                                        <div className='share_image' role="button" tabIndex={0}
                                          style={{ cursor: "pointer", background: "#f0f0f0", color: "black", padding: "0px 5px" }}
                                          onClick={() => setShowAllBcc(true)}
                                          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') setShowAllBcc(true) }}>
                                          +{bccSelectedItems.length - bccOverflow.visibleCount} more
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}</div>
                            }
                            <TopToolBoxClone3 style={{ display: "flex", alignItems: "center" }}>
                              <AutoComplete
                                style={{ width: "90%" }}
                                onSearch={BcchandleSearch}
                                onSelect={BcchandleSelect}
                                options={bccOptions}
                                value={bccInputValue}
                                onChange={handleBccPaste}
                              >
                                <Input placeholder='Bcc' />
                              </AutoComplete>

                              <div className="mail-cc" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: "5px", marginTop: 10 }}>
                                {CcOpen ? <></> : <span className="Email-CcBcc" role="button"
                                  tabIndex={0}
                                  onClick={handleCcOpen}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      handleCcOpen()
                                    }
                                  }}>Cc</span>
                                }
                                <span className="Email-CcBcc" role="button"
                                  tabIndex={0}
                                  onClick={() => setBccClose()}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                      setBccClose()
                                    }
                                  }}><s>Bcc</s></span>
                              </div>
                            </TopToolBoxClone3>
                          </div>
                        </div>
                        <div style={{ borderBottom: "1px Solid #c1c1c1", marginTop: 10 }} />
                      </div>}
                      <div className="group">
                        <Input placeholder="Subject" type="text" value={subject} onChange={(e) => setSubject(e.target.value)} />
                      </div>
                      <div className="template" style={{ display: "flex", alignItems: "center", gap: "25px" }}>
                        {(entity !== "MailPage" && entity === "EntityPages" && toSelectedItems.length === 1) &&
                          <div className="text_icon" role="button" style={{ cursor: "pointer" }}
                            tabIndex={0}
                            onClick={OpenTemplates}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                OpenTemplates()
                              }
                            }}>
                            <InsertTempIcon marginRight={5} width={14} height={14} /><span className="text_iconspace">Insert Template</span><DownOutlined style={{ fontSize: '12px' }} />
                          </div>
                        }
                        {!hasSignature ? (
                          <Buttons
                            type="text"
                            onClick={handleAddSignature}
                            className="signature-Button"
                          >
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <FeatherIcon icon="plus-circle" className="text_iconspace" size={15} />
                              Add Signature
                            </span>
                          </Buttons>
                        ) : (
                          <Buttons
                            type="text"
                            onClick={handleRemoveSignature}
                            className="signature-Button"
                          >
                            <span style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                              <FeatherIcon icon="x-circle" className="text_iconspace" size={15} />
                              Remove Signature
                            </span>
                          </Buttons>
                        )}
                      </div>
                      <div className="group">
                        <TinyMCEEditor IsTrackUrl={IsTrackUrl} placeholder="Compose email..." setContent={setContent} content={content} edit={edit} page="Email" setFiles={setFiles} height={400} selectedEntity="A" />
                      </div>
                      <div className="group" style={{ marginTop: "20px", display: "flex", gap: 10 }}>
                        {files.map((file, index) => {
                          const meta = fileTypeMeta(getFileExt(file.filename));
                          const FileTypeIcon = meta.icon;
                          return (
                            <figure
                              key={index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                                margin: 0,
                                padding: "5px",
                                border: "1px solid #e5e7eb",
                                borderRadius: 10,
                                background: "#fff",
                              }}
                            >
                              <div
                                className="attachment-image"
                                title={meta.label}
                                style={{
                                  width: 40,
                                  height: 40,
                                  borderRadius: 8,
                                  background: meta.soft,
                                  color: meta.color,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  flexShrink: 0,
                                }}
                              >
                                <FileTypeIcon size={20} strokeWidth={1.75} />
                              </div>
                              <figcaption style={{ flex: 1, marginTop: 0 }}>
                                <div title={file.filename} style={{
                                  cursor: "default",
                                  fontWeight: 700,
                                  fontSize: 12,
                                }}>{shortenFilename(file.filename, 20)}</div>
                                <div style={{
                                  display: "flex", alignItems: "center", justifyContent: "flex-start",
                                  gap: '10px',
                                  marginTop: '5px',
                                }}>
                                  <span style={{
                                    fontSize: 10,
                                    fontWeight: 600,
                                    color: "#4183f1",
                                    cursor: "pointer",
                                    flexGrow: 0,
                                  }} role="button" tabIndex={0}
                                    onClick={() => downloadAttachment(file)}
                                    onKeyDown={(event) => {
                                      if (event.key === 'Enter' || event.key === ' ') {
                                        downloadAttachment(file)
                                      }
                                    }}> Download
                                  </span>
                                  <span style={{
                                    fontSize: 10,
                                    fontWeight: 600,
                                    color: "red",
                                    cursor: "pointer",
                                    flexGrow: 0,
                                  }}>
                                    <FeatherIcon icon="trash-2" size={10} style={{ marginTop: 2 }} onClick={() => removeRow(index)} />
                                  </span>
                                </div>
                              </figcaption>
                            </figure>
                          );
                        })}
                      </div>
                    </div>}
                </div>
                {aiCompose ?
                  <div style={{
                    width: window.innerWidth <= 991 ? "100%" : "50%",
                    marginLeft: window.innerWidth <= 991 ? 0 : 15,
                    marginTop: window.innerWidth <= 991 ? 16 : 0,
                    borderLeft: window.innerWidth <= 991 ? "none" : "1px solid #eee",
                    borderTop: window.innerWidth <= 991 ? "1px solid #eee" : "none",
                    padding: "15px 20px 20px"
                  }} >
                    <div className="body">
                      <div className="group">
                        <div style={{
                          fontSize: "larger",
                          padding: "0px 0px 10px",
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#6a5af9"
                        }}> AI Assisted Draft</div>
                      </div>
                      <div className="group" style={{
                        border: "2px solid #eee",
                        padding: aiContent ? "20px 0px 20px 20px" : "0px",
                        borderRadius: "10px",
                        height: window.innerWidth <= 991 ? "auto" : "500px",
                        minHeight: window.innerWidth <= 991 ? "300px" : "500px",
                        overflowY: "auto"
                      }}>
                        {aiContent ? <CustomHtmlParser html={aiContent} key={1} page="Previews" /> :
                          <div className="spin" style={{ height: window.innerWidth <= 991 ? "300px" : "500px" }}>
                            <Spin />
                          </div>}
                      </div>
                    </div>
                    <div style={{ marginTop: 10, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <Button size="small" className="button_colors" onClick={() => MergeAiContent()} disabled={!aiContent}>
                        <FeatherIcon icon="arrow-left-circle" />  Insert Draft
                      </Button>
                      <Button size="small" onClick={() => onAiclose()} className="gray-button" disabled={disabled}>
                        <FeatherIcon icon="x" />Close
                      </Button>
                    </div>
                  </div> : ""}
              </div>
            </MailBox2 >
          </div >
        </Scrollbars >
      </Drawer >
      {openTemplate && <TemplateSelect openTemplate={openTemplate} setOpenTemplate={setOpenTemplate} setTemplateId={setTemplateId} entityName={entityName} />}
      {(popupMessage && page) && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={page} onDraftSend={onclose2} onDeleteSend={onDeleteSend} templateIDSS={templateID}
        OnCancel={OnCancel}
      />}
      <AiDraftConfirmPopup
        open={showAiDraftConfirm}
        onCancel={handleAiDraftCancel}
        onConfirm={handleAiDraftConfirm}
      />
    </>
  );
}

Compose.propTypes = {
  close: propTypes.func,
  entity: propTypes.string,
  entityName: propTypes.string,
  toId: propTypes.string,
  SendFunction: propTypes.func,
  DraftFunction: propTypes.func,
  setDetailsData: propTypes.func,
  mailOpen: propTypes.bool,
  replyToPopup: propTypes.string,
  forwardformatss: propTypes.object,
  templateIDSS: propTypes.number,
  AccountId: propTypes.number,
  detailsPage: propTypes.string,
  CallBackTrigger: propTypes.func,
  DeleteDraftForever: propTypes.func,
  setTemplateIDSS: propTypes.func,
  isCancel: propTypes.string,
  searchText: propTypes.string,
  Comefrom: propTypes.string,
  setNaCTrigger: propTypes.func,
  entityUId: propTypes.number,
  IsTrackUrl: propTypes.string,
};

Compose.defaultProps = {
  close: () => { },
};

export default Compose;